import { Component, OnInit, OnDestroy } from '@angular/core';
// import { CompanySiteToStoreService } from '../../company-site-to-store/company-site-to-store.service';
import { SitesService } from '../sites.service';
import { Site } from '../sites.model';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StripeResponseService } from 'src/app/services/stripe-response.service';

@Component({
  selector: 'app-sites-home',
  templateUrl: './sites-home.component.html',
  styleUrls: ['./sites-home.component.scss']
})
export class SitesHomeComponent implements OnInit, OnDestroy {
  public companyId: any;
  public siteId: any;
  public site: Site;
  private sub1: Subscription;
  private sub2: Subscription;

  constructor(
    private stripeResponseService: StripeResponseService,
    private sitesService: SitesService,
  ) { }

  ngOnInit(): void {



    this.companyId = this.stripeResponseService.companyId ;
    this.siteId = this.stripeResponseService.siteId;


    this.sub2 = this.sitesService.findSiteByCompanyIdSiteId(this.companyId, this.siteId)
      .subscribe((sites) => {

        if (sites.length === 0) { return; }
        this.site = sites[0];
      });

  }

  ngOnDestroy(): void {
    if (this.sub1) { this.sub1.unsubscribe(); }
    if (this.sub2) { this.sub2.unsubscribe(); }
  }

}
